<div class="wrapper">
	<div
		fxLayout="row"
		fxLayoutGap="30px"
		[ngClass]="{ 'is-loading': price?.isFetching }"
		*ngIf="!price?.isError && price?.price"
	>
		<div fxFlex class="price-note">
			<span i18n>Price with selected product options without delivery fees.</span>
		</div>
		<div data-cy="priceNumber" class="price-number">
			<g-icon
				@spinnerTrigger
				*ngIf="price?.isFetching"
				class="spinner"
				[icon]="icons.faSpinner"
				pulse
			></g-icon>
			<span *ngIf="showPricesWithTax$ | async">
				{{ price?.price?.price_with_tax || 0 | number: '1.2-2' }} €
			</span>
			<span *ngIf="!(showPricesWithTax$ | async)">
				{{ price?.price?.price_without_tax || 0 | number: '1.2-2' }} €
			</span>
			<g-vat-selector [taxMultiplier]="price?.price?.tax_multiplier"></g-vat-selector>
		</div>
	</div>
	<div
		fxLayout="row"
		fxLayoutGap="30px"
		[ngClass]="{ 'is-loading': price?.isFetching }"
		*ngIf="isVariableProduct && !price?.isError && !price?.price"
	>
		<div fxFlex class="price-note">
			<span i18n>Select all options to get the price</span>
		</div>
		<g-icon
			@spinnerTrigger
			*ngIf="price?.isFetching"
			class="spinner"
			[icon]="icons.faSpinner"
			pulse
		></g-icon>
		<div class="price-number" data-cy="priceNumber">
			<span *ngIf="showPricesWithTax$ | async"> - € </span>
		</div>
	</div>
	<div *ngIf="price?.isError" class="pricing-error" data-cy="pricingError" i18n>Pricing Error</div>
</div>
